import {
  TReviewData,
  TWinnerData,
  TWinnerPolaroidData
} from '@daymade/api-contracts';

export const isWinnerPolaroidType = (
  data: unknown,
): data is TWinnerPolaroidData => {
  if (typeof data !== 'object' || data === null) return false;
  const obj = data as Record<string, unknown>;
  
  // WinnerPolaroid only has: image, winnerName, prizeName
  // It should NOT have: title, winDate, videoLink, author, reviewDate, content
  return (
    !('title' in obj) &&
    !('winDate' in obj) &&
    !('videoLink' in obj) &&
    !('author' in obj) &&
    !('reviewDate' in obj) &&
    !('content' in obj) &&
    // Must have at least one of its fields
    ('image' in obj || 'winnerName' in obj || 'prizeName' in obj)
  );
};

export const isWinnerType = (data: unknown): data is TWinnerData => {
  if (typeof data !== 'object' || data === null) return false;
  const obj = data as Record<string, unknown>;
  
  // WinnerType has: image, winnerName, prizeName, title, winDate, videoLink
  // It should NOT have: author, reviewDate, content
  return (
    !('author' in obj) &&
    !('reviewDate' in obj) &&
    !('content' in obj) &&
    // Must have at least one distinguishing field
    ('winDate' in obj || 'videoLink' in obj)
  );
};

export const isReviewType = (data: unknown): data is TReviewData => {
  if (typeof data !== 'object' || data === null) return false;
  const obj = data as Record<string, unknown>;
  
  // ReviewType only has: title, author, reviewDate, content
  return (
    !('image' in obj) &&
    !('winnerName' in obj) &&
    !('prizeName' in obj) &&
    !('winDate' in obj) &&
    !('videoLink' in obj) &&
    // Must have at least one field
    ('title' in obj || 'author' in obj || 'reviewDate' in obj || 'content' in obj)
  );
};
